import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import ReactToPrint from "react-to-print";
import {
  getInvoiceItem,
  getServices,
  getSpecificInvoice,
} from "../../actions/invoiceItem";
import { getInvoiceMeasurement } from "../../actions/measurment";
import { getBusinessProfile } from "../../actions/settings";
import { getSpecificLocation } from "../../actions/warehouseAction";
import { getPaymentMethodsOfInvoice } from "../../actions/journalAction";

import {
  Form,
  Input,
  InputNumber,
  Checkbox,
  Button,
  Col,
  Row,
  Select,
  message,
  TreeSelect,
  Space,
  Divider,
  Drawer,
  Image,
  Skeleton,
} from "antd";

const { Option } = Select;

const Quickview = ({
  details,
  getInvoiceItem,
  getServices,
  getBusinessProfile,
  businessprofile,
  getInvoiceMeasurement,
  getSpecificLocation,
  getSpecificInvoice,
  getPaymentMethodsOfInvoice,
  brandlist
}) => {
  var formatter = new Intl.NumberFormat("en-IN");
  const componentRef = useRef();
  const [visible, setVisible] = useState(false);
  const [loading, setloading] = useState(true);
  const [data, setdata] = useState([]);
  const [measurements, setmeasurements] = useState([]);
  const [branch, setbranch] = useState([]);
  const [services, setservices] = useState([]);
  const count = useRef(0);
  const quantity = useRef(0);
  const serialcount = useRef(0);

  const showDrawer = () => {
    getPaymentMethodsOfInvoice(details.id);
    getSpecificInvoice(details.id).then((result) => {
      console.log(result);
    });
    getSpecificLocation(details.location).then((result) => {
      setbranch(result);
    });
    getInvoiceItem(details.id).then((e) => {
      getBusinessProfile();
      getServices(details.id).then((service) => {
        getInvoiceMeasurement(details.id).then((result) => {
          if (result.length > 0) {
            setmeasurements(result[0]);
          } else {
            setmeasurements(false);
          }
          count.current = e.length + service.filter(item => parseFloat(item.price) !== 0).length;
          // quantity.current = e.length + service.length;
          if (count.current < 9) count.current = 9 - count.current;
          else {
            count.current = 0;
          }
          setdata([...e, ...service.filter(item => parseFloat(item.price) !== 0)]);

          setloading(false);
          setservices(service.filter(item => parseFloat(item.price) !== 0));
        });
      });
    });
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };
  const renderImage = () => {
    if (loading) {
      return <Skeleton active />;
    } else {
      return (
        <img
          src={branch.logo}
          style={{
            // width: "100%",
            right: "0",
            maxHeight: "60px"
          }}
        />
      );
    }
  };
  const renderitems = () => {
    if (loading) {
      return <Skeleton active />;
    } else {
      quantity.current = 0;
      return data.map((item, index) => {
        if (item?.realter) {
          if (item.price > 0) {
            quantity.current += item.quantity;
            serialcount.current = index + 1;
            return (
              <>
                <tr>
                  <td>{index + 1}</td>
                  {item.details ? (
                    <td>
                      {" "}
                      <div
                        className="d-div"
                        dangerouslySetInnerHTML={{ __html: item.details }}
                      ></div>
                    </td>
                  ) : (
                    <td> {item.Details}</td>
                  )}

                  {/* <td>{formatter.format(item.price)}</td> */}

                  <td style={{ textAlign: "center", margin: "auto" }}>
                    {item.quantity}
                  </td>
                  {/* <td style={{ textAlign: "center", margin: "auto" }}>
                    {formatter.format(item.price * item.quantity)}
                  </td> */}
                </tr>
              </>
            );
          } else return "";
        } else {
          quantity.current += item.quantity;
          serialcount.current = index + 1;
          return (
            <>
              <tr>
                <td>{index + 1}</td>
                {item.details ? (
                  <td>
                    {" "}
                    <div
                      className="d-div"
                      dangerouslySetInnerHTML={{ __html: item.details }}
                    ></div>
                  </td>
                ) : (
                  <td> {item.Details}</td>
                )}

                {/* <td>{formatter.format(item.price)}</td> */}

                <td style={{ textAlign: "center", margin: "auto" }}>
                  {item.quantity}
                </td>
                {/* <td style={{ textAlign: "center", margin: "auto" }}>
                  {formatter.format(item.price * item.quantity)}
                </td> */}
              </tr>
            </>
          );
        }
      });
    }
  };

  const renderblanktables = () => {
    if (loading) {
      return "";
    } else {
      let indexcount = 0;
      return Array.apply(null, Array(count.current)).map(() => {
        indexcount = indexcount + 1;
        return (
          <tr>
            <td>{serialcount.current + indexcount}</td>
            {/* <td></td> */}
            <td></td>
            <td></td>
            {/* <td></td> */}
            {/* <td></td> */}
          </tr>
        );
      });
    }
  };

  return (
    <>
      <>
        <a href="#" onClick={showDrawer} style={{ margin: 4 }}>
          Gift card
        </a>
        <Drawer
          width="850"
          onClose={onClose}
          visible={visible}
          placement="right"
          bodyStyle={{ margin: 0 }}
        >
          <ReactToPrint
            trigger={() => <button>Print this out!</button>}
            content={() => componentRef.current}
          />
          <div style={{ display: "none" }}>
            <div
              className="invoice_print_fontSize"
              ref={componentRef}
              style={{ padding: "10px" }}
            >
              <Row
                className="invoice_print_fontSize"
                style={{
                  borderBottom: "2px solid lightgray",
                  paddingBottom: "5px",
                }}
              >
                <Col
                  span={8}
                  style={{
                    paddingTop: "45px",
                  }}
                >
                  INVOICE NO.{" "}
                  {details.invoice_number ? (
                    <b>{details.invoice_number}</b>
                  ) : (
                    ""
                  )}
                </Col>
                <Col span={8} style={{ textAlign: "center" }}>
                  {renderImage()}
                </Col>
                <Col
                  span={8}
                  style={{
                    textAlign: "right",
                    paddingTop: "15px",
                  }}
                >
                  MUSHAK 6.3<br></br>
                  BIN : 005377776-0101
                  <br></br> ORDER NO.{" "}
                  {details.order_number ? <b>{details.order_number}</b> : ""}
                </Col>
              </Row>
              {details.contact ? (
                <>
                  <Row>
                    <Col span={16}>
                      <p style={{ display: "inline-block" }}>CLIENT NAME : </p>
                      {details.Contact[0].name ? (
                        <> {details.Contact[0].name}</>
                      ) : (
                        ""
                      )}
                    </Col>
                    <Col span={8} style={{ textAlign: "right" }}>
                      <p style={{ display: "inline-block" }}>CONTACT : </p>
                      {details.Contact[0].phone ? (
                        <> {details.Contact[0].phone}</>
                      ) : (
                        ""
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <p style={{ display: "inline-block" }}>ADDRESS : </p>
                      {details.Contact[0].address ? (
                        <> {details.Contact[0].address}</>
                      ) : (
                        ""
                      )}
                    </Col>
                  </Row>
                </>
              ) : (
                <></>
              )}
              <Row>
                <Col span={24}>
                  <p style={{ display: "inline-block" }}>SHIPPING ADDRESS : </p>
                  {details.shipping_address ? (
                    <> {details.shipping_address}</>
                  ) : (
                    ""
                  )}
                </Col>
              </Row>
              {/* 
          
          {/* <Divider /> */}

              <Row>
                <Col span={18}>
                  <table className="product_table invoice_print_fontSize">
                    <tbody>
                      <tr style={{ fontWeight: "500" }}>
                        <td>NO</td>
                        <td>PRODUCT DETAILS</td>
                        {/* <td>DESIGN CODE</td> */}
                        {/* <td>RATE</td> */}
                        <td>QTY</td>
                        {/* <td>AMOUNT</td> */}
                      </tr>
                      {renderitems()}
                      {/* {renderservices()} */}
                      {renderblanktables()}
                      <tr>
                        <td
                          colSpan={2}
                          style={{ textAlign: "right", paddingRight: "10px" }}
                        >
                          Total Quantity
                        </td>
                        <td>{quantity.current}</td>
                      </tr>
                    </tbody>
                  </table>
                  <h4 style={{ textAlign: "left", marginTop: "5px" }}>We hope you enjoy your gift</h4>
                  {/* <Row>
                    <Col
                      span={6}
                      style={{ textAlign: "left", marginTop: "5px" }}
                    >
                      <h3
                        style={{
                          borderBottom: "2px solid gray",
                          display: "inline-block",
                        }}
                      >
                        PAYMENT METHOD
                      </h3>
                      <br></br>
                      <table style={{ width: "100%" }}>
                        {details?.payment_methods?.map((method) => {
                          return (
                            <>
                              <tr>
                                <td>
                                  <small>{method.method}</small>
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  <small>
                                    {formatter.format(method.amount)}
                                  </small>
                                </td>
                              </tr>
                            </>
                          );
                        })}
                      </table>
                    </Col>
                    <Col
                      span={9}
                      style={{ textAlign: "right", marginTop: "5px" }}
                    >
                      {details.tax > 0 ? (
                        <>
                          <Row>
                            <Col span={14} style={{ margin: "auto" }}>
                              VAT
                            </Col>
                            <Col span={9} offset={1}>
                              <span className="order_span_bill">
                                {formatter.format(details.tax)}
                              </span>
                            </Col>
                          </Row>
                        </>
                      ) : (
                        ""
                      )}
                      {details.delivery_charge > 0 ? (
                        <>
                          <Row>
                            <Col span={14} style={{ margin: "auto" }}>
                              DELIVERY CHARGE
                            </Col>
                            <Col span={9} offset={1}>
                              <span className="order_span_bill">
                                {formatter.format(details.delivery_charge)}
                              </span>
                            </Col>
                          </Row>
                        </>
                      ) : (
                        ""
                      )}
                      {details.discount > 0 ? (
                        <>
                          <Row>
                            <Col span={14} style={{ margin: "auto" }}>
                              DISCOUNT
                            </Col>
                            <Col span={9} offset={1}>
                              <span className="order_span_bill">
                                {formatter.format(details.discount)}
                              </span>
                            </Col>
                          </Row>
                        </>
                      ) : (
                        ""
                      )}
                    </Col>

                    <Col
                      span={9}
                      style={{ textAlign: "right", marginTop: "5px" }}
                    >
                      <Row>
                        <Col span={14} style={{ margin: "auto" }}>
                          SUB TOTAL
                        </Col>
                        <Col span={9} offset={1}>
                          <span className="order_span_bill">
                            {formatter.format(
                              parseFloat(details.bill) +
                              parseFloat(details.discount)
                            )}
                          </span>
                        </Col>
                      </Row>
                      <Row>
                        <Col span={14} style={{ margin: "auto" }}>
                          TOTAL AMOUNT
                        </Col>
                        <Col span={9} offset={1}>
                          <span className="order_span_bill">
                            {formatter.format(details.bill)}
                          </span>
                        </Col>
                      </Row>

                      <Row>
                        <Col span={14} style={{ margin: "auto" }}>
                          TOTAL PAYMENT
                        </Col>
                        <Col span={9} offset={1}>
                          <span className="order_span_bill">
                            {formatter.format(details.payment)}
                          </span>
                        </Col>
                      </Row>
                      <Row>
                        <Col span={14} style={{ margin: "auto" }}>
                          BALANCE DUE
                        </Col>
                        <Col span={9} offset={1}>
                          <span className="order_span_bill">
                            {formatter.format(details.due)}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                  </Row> */}
                </Col>
                <Col span={6}>
                  <Row style={{ textAlign: "center" }}>
                    <Col span={24} style={{ marginTop: "5px" }}>
                      SHOWROOM CONTACT
                      <span className="order_span">
                        {branch.contact ? branch.contact : ""}
                      </span>
                    </Col>
                    <Col span={24} style={{ marginTop: "5px" }}>
                      ORDER DATE
                      <span className="order_span">{details.issue_date}</span>
                    </Col>
                    <Col span={24} style={{ marginTop: "5px" }}>
                      DELIVERY DATE
                      <span className="order_span">
                        {details.delivery_date ? details.delivery_date : "-"}
                      </span>
                    </Col>
                    <Col span={24} style={{ marginTop: "5px" }}>
                      PROGRAM DATE
                      <span className="order_span">
                        {details.program_date ? details.program_date : "-"}
                      </span>
                    </Col>
                    <Col span={24} style={{ marginTop: "5px" }}>
                      SALES PERSON
                      <span className="order_span">
                        {details.Sales_person_name
                          ? details.Sales_person_name
                          : "-"}
                      </span>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col span={8}>
                  <br></br>
                  <h3>ADDRESS</h3>
                  <small>
                    <div
                      className="d-div"
                      dangerouslySetInnerHTML={{
                        __html: branch.address,
                      }}
                    ></div>
                  </small>
                </Col>
                <Col span={15} offset={1}>
                  <br></br>
                  <h3>TERMS & CONDITIONS</h3>
                  <small>
                    <div
                      className="d-div"
                      dangerouslySetInnerHTML={{
                        __html: businessprofile.invoice_terms,
                      }}
                    ></div>
                  </small>
                  <br></br>

                  <Row style={{ minHeight: "60px" }}>
                    <Col span={12} style={{ textAlign: "center" }}>
                      <img
                        src={businessprofile.signature}
                        style={{
                          maxHeight: "60px",
                          // marginleft: "200px",
                        }}
                      />
                    </Col>
                    <Col span={12} style={{ textAlign: "center" }}></Col>
                  </Row>
                  <Row>
                    <Col span={12} style={{ textAlign: "center" }}>
                      <h3
                        style={{
                          marginLeft: "40px",
                          borderTop: "2px solid black",
                          width: "70%",
                        }}
                      >
                        SIGNATURE
                      </h3>
                    </Col>
                    <Col span={12} style={{ textAlign: "center" }}>
                      <h3
                        style={{
                          marginLeft: "40px",

                          marginBottom: "-5px",
                          padding: "0px",
                          borderTop: "2px solid black",
                          width: "70%",
                        }}
                      >
                        CLIENT SIGNATURE
                      </h3>
                      <small>(WITH DATE)</small>
                    </Col>
                  </Row>
                </Col>
              </Row>


            </div>
          </div>
          <div className="invoice_print_fontSize_quick">
            <Row
              style={{
                borderBottom: "2px solid lightgray",
                paddingBottom: "5px",
              }}
            >
              <Col
                span={8}
                style={{
                  paddingTop: "45px",
                }}
              >
                INVOICE NO.{" "}
                {details.invoice_number ? <b>{details.invoice_number}</b> : ""}
              </Col>
              <Col span={8} style={{ textAlign: "center" }}>
                {renderImage()}
              </Col>
              <Col
                span={8}
                style={{
                  textAlign: "right",
                  paddingTop: "15px",
                }}
              >
                MUSHAK 6.3<br></br>
                BIN : 005377776-0101<br></br> ORDER NO.{" "}
                {details.order_number ? <b>{details.order_number}</b> : ""}
              </Col>
            </Row>
            {details.contact ? (
              <>
                <Row>
                  <Col span={16}>
                    <p style={{ display: "inline-block" }}>CLIENT NAME : </p>
                    {details.Contact[0].name ? (
                      <> {details.Contact[0].name}</>
                    ) : (
                      ""
                    )}
                  </Col>
                  <Col span={8} style={{ textAlign: "right" }}>
                    <p style={{ display: "inline-block" }}>CONTACT : </p>
                    {details.Contact[0].phone ? (
                      <> {details.Contact[0].phone}</>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <p style={{ display: "inline-block" }}>ADDRESS : </p>
                    {details.Contact[0].address ? (
                      <> {details.Contact[0].address}</>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
              </>
            ) : (
              <></>
            )}
            <Row>
              <Col span={24}>
                <p style={{ display: "inline-block" }}>SHIPPING ADDRESS : </p>
                {details.shipping_address ? (
                  <> {details.shipping_address}</>
                ) : (
                  ""
                )}
              </Col>
            </Row>
            {/* 
          
          {/* <Divider /> */}

            <Row>
              <Col span={18}>
                <table className="product_table_quick">
                  <tbody>
                    <tr style={{ fontWeight: "500" }}>
                      <td>NO</td>
                      <td>PRODUCT DETAILS</td>

                      {/* <td>RATE</td> */}
                      <td>QTY</td>
                      {/* <td>AMOUNT</td> */}
                    </tr>
                    {renderitems()}

                    {renderblanktables()}
                    <tr>
                      <td
                        colSpan={2}
                        style={{ textAlign: "right", paddingRight: "10px" }}
                      >
                        Total Quantity
                      </td>
                      <td>{quantity.current}</td>
                    </tr>
                  </tbody>
                </table>
                <h4 style={{ textAlign: "left", marginTop: "5px" }}>We hope you enjoy your gift</h4>
                {/* <Row>
                  <Col span={6} style={{ textAlign: "left", marginTop: "5px" }}>
                    <h3
                      style={{
                        borderBottom: "2px solid gray",
                        display: "inline-block",
                      }}
                    >
                      PAYMENT METHOD
                    </h3>
                    <br></br>
                    <table style={{ width: "100%" }}>
                      {details?.payment_methods?.map((method) => {
                        return (
                          <>
                            <tr>
                              <td>
                                <small>{method.method}</small>
                              </td>
                              <td style={{ textAlign: "right" }}>
                                <small>{formatter.format(method.amount)}</small>
                              </td>
                            </tr>
                          </>
                        );
                      })}
                    </table>
                  </Col>
                  <Col
                    span={9}
                    style={{ textAlign: "right", marginTop: "5px" }}
                  >
                    {details.tax > 0 ? (
                      <>
                        <Row>
                          <Col span={14} style={{ margin: "auto" }}>
                            VAT
                          </Col>
                          <Col span={9} offset={1}>
                            <span className="order_span_bill">
                              {formatter.format(details.tax)}
                            </span>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    )}
                    {details.delivery_charge > 0 ? (
                      <>
                        <Row>
                          <Col span={14} style={{ margin: "auto" }}>
                            DELIVERY CHARGE
                          </Col>
                          <Col span={9} offset={1}>
                            <span className="order_span_bill">
                              {formatter.format(details.delivery_charge)}
                            </span>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    )}
                    {details.discount > 0 ? (
                      <>
                        <Row>
                          <Col span={14} style={{ margin: "auto" }}>
                            DISCOUNT
                          </Col>
                          <Col span={9} offset={1}>
                            <span className="order_span_bill">
                              {formatter.format(details.discount)}
                            </span>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    )}
                  </Col>

                  <Col
                    span={9}
                    style={{ textAlign: "right", marginTop: "5px" }}
                  >
                    <Row>
                      <Col span={14} style={{ margin: "auto" }}>
                        SUB TOTAL
                      </Col>
                      <Col span={9} offset={1}>
                        <span className="order_span_bill">
                          {formatter.format(
                            parseFloat(details.bill) +
                            parseFloat(details.discount)
                          )}
                        </span>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={14} style={{ margin: "auto" }}>
                        TOTAL AMOUNT
                      </Col>
                      <Col span={9} offset={1}>
                        <span className="order_span_bill">
                          {formatter.format(details.bill)}
                        </span>
                      </Col>
                    </Row>

                    <Row>
                      <Col span={14} style={{ margin: "auto" }}>
                        TOTAL PAYMENT
                      </Col>
                      <Col span={9} offset={1}>
                        <span className="order_span_bill">
                          {formatter.format(details.payment)}
                        </span>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={14} style={{ margin: "auto" }}>
                        BALANCE DUE
                      </Col>
                      <Col span={9} offset={1}>
                        <span className="order_span_bill">
                          {formatter.format(details.due)}
                        </span>
                      </Col>
                    </Row>
                  </Col>
                </Row> */}
              </Col>
              <Col span={6}>
                <Row style={{ textAlign: "center" }}>
                  <Col span={24} style={{ marginTop: "5px" }}>
                    SHOWROOM CONTACT
                    <span className="order_span">
                      {branch.contact ? branch.contact : ""}
                    </span>
                  </Col>
                  <Col span={24} style={{ marginTop: "5px" }}>
                    ORDER DATE
                    <span className="order_span">{details.issue_date}</span>
                  </Col>
                  <Col span={24} style={{ marginTop: "5px" }}>
                    DELIVERY DATE
                    <span className="order_span">
                      {details.delivery_date ? details.delivery_date : "-"}
                    </span>
                  </Col>
                  <Col span={24} style={{ marginTop: "5px" }}>
                    PROGRAM DATE
                    <span className="order_span">
                      {details.program_date ? details.program_date : "-"}
                    </span>
                  </Col>
                  <Col span={24} style={{ marginTop: "5px" }}>
                    SALES PERSON
                    <span className="order_span">
                      {details.Sales_person_name
                        ? details.Sales_person_name
                        : "-"}
                    </span>
                  </Col>
                </Row>
              </Col>
            </Row>
            {/* <Divider /> */}
            <Row>
              <Col span={8}>
                <br></br>
                <h3>ADDRESS</h3>
                <small>
                  <div
                    className="d-div"
                    dangerouslySetInnerHTML={{
                      __html: branch.address,
                    }}
                  ></div>
                </small>
              </Col>
              <Col span={15} offset={1}>
                <br></br>
                <h3>TERMS & CONDITIONS</h3>
                <small>
                  <div
                    className="d-div"
                    dangerouslySetInnerHTML={{
                      __html: businessprofile.invoice_terms,
                    }}
                  ></div>
                </small>
                <br></br>

                <Row style={{ minHeight: "60px" }}>
                  <Col span={12} style={{ textAlign: "center" }}>
                    <img
                      src={businessprofile.signature}
                      style={{
                        maxHeight: "60px",
                        // marginleft: "200px",
                      }}
                    />
                  </Col>
                  <Col span={12} style={{ textAlign: "center" }}></Col>
                </Row>
                <Row>
                  <Col span={12} style={{ textAlign: "center" }}>
                    <h3
                      style={{
                        marginLeft: "40px",
                        borderTop: "2px solid black",
                        width: "70%",
                      }}
                    >
                      SIGNATURE
                    </h3>
                  </Col>
                  <Col span={12} style={{ textAlign: "center" }}>
                    <h3
                      style={{
                        marginLeft: "40px",

                        marginBottom: "-5px",
                        padding: "0px",
                        borderTop: "2px solid black",
                        width: "70%",
                      }}
                    >
                      CLIENT SIGNATURE
                    </h3>
                    <small>(WITH DATE)</small>
                  </Col>
                </Row>
              </Col>
            </Row>


          </div>
        </Drawer>
      </>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    businessprofile: state.settings.businessprofile,
    brandlist: state.brand.brandlist,
  };
};

export default connect(mapStateToProps, {
  getInvoiceItem,
  getServices,
  getBusinessProfile,
  getInvoiceMeasurement,
  getSpecificLocation,
  getSpecificInvoice,
  getPaymentMethodsOfInvoice,
})(Quickview);
